import FingerprintJS from "@fingerprintjs/fingerprintjs";

let cachedId: string | null = null;

/**
 * Returns a stable browser fingerprint (visitorId). Cached in memory for the session.
 * Not stored in localStorage to avoid tampering. BE validates format (16-256 chars).
 */
export async function getFingerprint(): Promise<string> {
  if (cachedId) return cachedId;
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  cachedId = result.visitorId;
  return cachedId;
}
